export default __webpack_public_path__ + "static/media/description-header.9d30b75e.png";